var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42.5 42.5",
    style: {
      enableBackground: "new 0 0 42.5 42.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FBBA00;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circulo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.5,21.3c0,11.7-9.5,21.3-21.3,21.3S0,33,0,21.3S9.5,0,21.3,0S42.5,9.5,42.5,21.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.7,18.5v2.1h2.9v1.5H7.7v3.3h-2V17h5.6l-0.3,1.5C11.1,18.5,7.7,18.5,7.7,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.6,25.5h-2L17,23.6h-3.2l-0.6,1.9h-2l3.3-8.5h2C16.4,17,19.7,25.5,19.6,25.5z M16.5,22.3l-0.8-2.3 c-0.1-0.1-0.1-0.3-0.2-0.5s-0.1-0.4-0.2-0.6c-0.1,0.2-0.1,0.5-0.2,0.7S15,19.8,15,20l-0.8,2.3L16.5,22.3L16.5,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.4,21.3c0,0.6-0.1,1.2-0.3,1.7s-0.5,1-0.9,1.4c-0.4,0.4-0.9,0.7-1.4,0.9c-0.5,0.2-1.1,0.3-1.8,0.3h-3.3 V17H24c0.7,0,1.3,0.1,1.8,0.3c0.5,0.2,1,0.5,1.4,0.9s0.7,0.8,0.9,1.4C28.3,20.1,28.4,20.7,28.4,21.3L28.4,21.3z M26.4,21.3 c0-0.4,0-0.8-0.2-1.1s-0.3-0.6-0.5-0.9c-0.2-0.2-0.5-0.4-0.8-0.5c-0.3-0.1-0.6-0.2-1-0.2h-1.3V24H24c0.4,0,0.7-0.1,1-0.2 c0.3-0.1,0.5-0.3,0.8-0.5c0.2-0.2,0.4-0.5,0.5-0.9C26.3,22.1,26.4,21.7,26.4,21.3L26.4,21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.3,24c0.3,0,0.5,0,0.7-0.1c0.2-0.1,0.4-0.2,0.5-0.4c0.1-0.2,0.2-0.4,0.3-0.6S35,22.3,35,22v-5h2v5 c0,0.5-0.1,1-0.2,1.4s-0.4,0.8-0.7,1.1c-0.3,0.3-0.7,0.6-1.2,0.7c-0.5,0.2-1,0.3-1.5,0.3s-1.1-0.1-1.5-0.3 c-0.5-0.2-0.8-0.4-1.1-0.7s-0.6-0.7-0.7-1.1c-0.2-0.4-0.2-0.9-0.2-1.4v-5h2v5c0,0.3,0,0.6,0.1,0.8c0.1,0.2,0.2,0.4,0.3,0.6 c0.1,0.2,0.3,0.3,0.5,0.4C32.8,23.9,33,23.9,33.3,24L33.3,24z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.eb1ce87e8f86dfc522918f834bedb4b7.svg";
export { ForwardRef as ReactComponent };